<template>
  <div class="aj-tree-tab" :style="{ '--bgColor': color }">
    <div class="aj-radio-tree-group" :class="flexWrap?'flex-wrap':''">
      <div v-for="item in getOptionList" :key="item[tabValue]" class="aj-radio-item" @click="changeRadio(item[tabValue])" :class="activeTab == item[tabValue] ? 'aj-radio-item-active' : ''">{{ item[tabLabel] }}</div>
    </div>
    <infineRadio v-model="childValue" v-if="nextList.length > 0" :optionList="nextList" :tabIndex="tabIndex + 1" :hasAll="hasAll" :tabLabel="tabLabel" :tabValue="tabValue" :tabChild="tabChild" :color="color" @change="change"></infineRadio>
  </div>
</template>

<script>
// import infineTab from './infineTab.vue';
export default {
  name: 'infineRadio',
  props: {
    tabLabel: {
      type: String,
      default: 'label'
    },
    tabValue: {
      type: String,
      default: 'value'
    },
    tabChild: {
      type: String,
      default: 'children'
    },
    color: {
      type: String,
      default: '#3775ff'
    },
    optionList: {
      type: Array,
      default: () => []
    },
    tabIndex: {
      type: Number,
      default: 0
    },
    hasAll: {
      type: String,
      default: null
    },
    checkOut: {
      type: Boolean,
      default: false
    },
    flexWrap:{
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {
    activeTab: {
      get() {
        return this.value[this.tabIndex] ? this.value[this.tabIndex] : '';
      },
      set(value) {
        // const newList = JSON.parse(JSON.stringify(this.value));
        // newList[this.tabIndex] = value;
        // let valueList = [];
        // for (let i = 0; i <= this.tabIndex; i++) {
        //   valueList.push(newList[i]);
        // }
        // this.$emit('input', valueList);
      }
    },
    childValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    nextList: {
      get() {
        const selItem = this.findItem(this.optionList, this.tabValue, this.activeTab);
        if (selItem && selItem[this.tabChild] && selItem[this.tabChild].length > 0) {
          return selItem[this.tabChild];
        } else {
          return [];
        }
      }
    },
    getOptionList: {
      get() {
        if (this.hasAll) {
          let list = JSON.parse(JSON.stringify(this.optionList));
          let obj = {};
          obj[this.tabLabel] = '全部';
          obj[this.tabValue] = this.hasAll ? this.hasAll : 'all';
          list.unshift(obj);
          return list;
        } else {
          return this.optionList;
        }
      }
    }
  },
  methods: {
    changeRadio(data) {
      if (data != this.activeTab) {
        const newList = JSON.parse(JSON.stringify(this.value));
        newList[this.tabIndex] = data;
        let valueList = [];
        for (let i = 0; i <= this.tabIndex; i++) {
          valueList.push(newList[i]);
        }
        if (!this.checkOut) {
          let obj = this.getOptionList.find(item => {
            return item[this.tabValue] == data;
          });
          if (obj && obj[this.tabChild]&& obj[this.tabChild].length>0) {
            valueList.push('all');
          }
        }
        this.$nextTick(() => {
          this.$emit('input', valueList);
          this.$emit('change', valueList);
        });
      } else {
        if (this.checkOut) {
          // 反选逻辑
          const newList = JSON.parse(JSON.stringify(this.value));
          newList[this.tabIndex] = data;
          let valueList = [];
          for (let i = 0; i < this.tabIndex; i++) {
            valueList.push(newList[i]);
          }
          this.$emit('input', valueList);
          this.$emit('change', valueList);
        }
      }
    },
    change(data) {
      this.$emit('change', data);;
    },
    // 找item
    findItem(list, key, value) {
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        if (item[key] === value) {
          return item;
        }
        if (item[this.tabChild] && item[this.tabChild].length > 0) {
          if (this.findItem(item[this.tabChild], key, value)) {
            return this.findItem(item[this.tabChild], key, value);
          }
        }
      }
      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.aj-tree-tab {
  width: 100%;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  // display: flex;
  .aj-radio-tree-group {
    display: flex;
    .aj-radio-item {
      // margin-left: 0;
      flex-shrink: 0;
      margin-bottom: 0.5rem;
      margin-right: 0.5rem;
      background-color: rgb(224, 232, 246);
      line-height: none;
      padding: 0.3rem 1rem;
      border-radius: 0.9rem;
      font-size: 0.8rem;
      line-height: normal;
    }
    .aj-radio-item-active {
      background-color: #3775ff;
      color: #fff;
    }
  }
  .flex-wrap{
    flex-wrap: wrap;
  }
}
</style>
